import { ReactNode } from "react";
import styled from "@emotion/styled";
import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

interface AgentSurfacePlaceholderProps {
  eyebrow: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export const AgentSurfacePlaceholder = ({
  eyebrow,
  title,
  description,
  children,
}: AgentSurfacePlaceholderProps) => {
  return (
    <Wrapper>
      <Content>
        <MDSText variant={MDSTextVariant.TextXs} color={MDSTextColor.Secondary}>
          {eyebrow}
        </MDSText>
        <Title variant={MDSTextVariant.HeaderXl}>{title}</Title>
        <Description variant={MDSTextVariant.ParagraphS} color={MDSTextColor.Secondary}>
          {description}
        </Description>
        {children}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing[8]};
`;

const Content = styled.div`
  display: flex;
  width: min(720px, 100%);
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[4]};
`;

const Title = styled(MDSText)`
  max-width: 640px;
`;

const Description = styled(MDSText)`
  max-width: 560px;
`;
